import React, { memo } from 'react'

import DataTable from './DataTable/DataTable'

const structureCard = ({
    structureType,
    structureData,
    adding,
    editing,
    deleting,
    loading,
    addDisabled,
    editDisabled,
    deleteDisabled
}) => {

    return (
        <div style={{ width: '100%' }}>
            <DataTable
                recordData={structureData}
                structureName={structureData.csg_name}
                structureType={structureType}
                editButtonClicked={editing}
                deleteButtonClicked={deleting}
                addButtonClicked={adding}
                addDisabled={addDisabled}
                editDisabled={editDisabled}
                deleteDisabled={deleteDisabled}
                loading={loading}
            />
        </div>
    )
}

export default memo(structureCard)
